// @ts-nocheck

import { map } from 'lodash';
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import styled, { css } from 'styled-components';

import routes from '../../routes/betting';
import { MenuStyle } from '../../styled-components/desktop/menu';
import SearchBarContainer from '../SearchBar/SearchBarContainer';

const StyledLeftColumn = styled(MenuStyle)`
  width: 350px;
  margin-right: 10px;

  ${({ theme }) => css`
    @media screen and (min-width: ${theme.breakpoints.lg}px) and (max-width: ${theme.breakpoints.xl - 1}px) {
      margin-right: 53px;
    }

    @media screen and (min-width: ${theme.breakpoints.lg}px) and (max-width: ${theme.breakpoints.xl - 1}px) {
      margin-right: 53px;
    }

    @media screen and (min-width: ${theme.breakpoints.xl}px) {
      margin-right: 120px;
    }
    @media screen and (min-width: ${theme.breakpoints.sm}px) and (max-width: ${theme.breakpoints.md}px) {
      width: 275px;
    }
  `}
`;

export const SearchWrapper = styled.div`
  width: 100%;
`;

/**
 * Display the left colum for the betting section
 * @return {ReactNode} A styled component wrapper with the search bar and all the necessary routes
 */
const DesktopBettingLayoutLeftColumn = () => {
  return (
    <StyledLeftColumn data-testid="leftColumn">
      <SearchWrapper>
        <SearchBarContainer />
      </SearchWrapper>
      <Switch>
        {map(routes, ({ pattern, Menu, exact }, key) => (
          <Route key={key} path={pattern} exact={exact}>
            <Menu />
          </Route>
        ))}
      </Switch>
    </StyledLeftColumn>
  );
};

export default React.memo<typeof StyledLeftColumn>(DesktopBettingLayoutLeftColumn);
